export enum Form2FARecoveryButtonLabel {
  Continue = 'Continue',
  Print = 'Print Phrase',
  Back = 'Go Back'
}
